/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { ScaffoldComponent } from './scaffold';
export * from './scaffold-constants';
export * from './scaffold';
export function defineScaffoldComponent() {
    defineCustomElement(ScaffoldComponent);
}
